import type { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import BookingPage from '../pages/booking/page';
import GalleryPage from '../pages/gallery/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';
import AdminPage from '../pages/admin/page';
import HomeSettingsPage from '../pages/admin/home-settings/page';
import ResetPasswordPage from '../pages/auth/ResetPasswordPage';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '/admin/home-settings',
    element: <HomeSettingsPage />
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />
  }
];

export default routes;
